import Auth from '@js/plugins/auth';
import Feature from '@js/plugins/feature';

export default {
    computed: {
        canManageCoupon() {
            return (
                Feature.hasFeature('coupon') &&
                Auth.hasPermissionTo('franchise_manage_marketing')
            );
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory/coupon/coupon-permission.js